import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

type FlagProps = { width: number; height: number };

/** Россия — триколор 2:3 */
export function FlagRussia({ width, height }: FlagProps) {
  const h3 = height / 3;
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <Rect x={0} y={0} width={width} height={h3} fill="#ffffff" />
      <Rect x={0} y={h3} width={width} height={h3} fill="#0039a6" />
      <Rect x={0} y={h3 * 2} width={width} height={h3} fill="#d52b1e" />
    </Svg>
  );
}

/** Сербия — государственный триколор 2:3 (красный, синий, белый) */
export function FlagSerbia({ width, height }: FlagProps) {
  const h3 = height / 3;
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <Rect x={0} y={0} width={width} height={h3} fill="#c6363c" />
      <Rect x={0} y={h3} width={width} height={h3} fill="#0c4076" />
      <Rect x={0} y={h3 * 2} width={width} height={h3} fill="#ffffff" />
    </Svg>
  );
}

/** France — drapeau tricolore 2:3 */
export function FlagFrance({ width, height }: FlagProps) {
  const w3 = width / 3;
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <Rect x={0} y={0} width={w3} height={height} fill="#002395" />
      <Rect x={w3} y={0} width={w3} height={height} fill="#ffffff" />
      <Rect x={w3 * 2} y={0} width={w3} height={height} fill="#ED2939" />
    </Svg>
  );
}

/** Великобритания — Union Jack, упрощённая геометрия в viewBox 60×30 */
export function FlagUnitedKingdom({ width, height }: FlagProps) {
  return (
    <Svg width={width} height={height} viewBox="0 0 60 30">
      <Rect width={60} height={30} fill="#012169" />
      <Path d="M0,0 L60,30 M60,0 L0,30" stroke="#ffffff" strokeWidth={10} />
      <Path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth={6} />
      <Path d="M30,0 L30,30 M0,15 L60,15" stroke="#ffffff" strokeWidth={12} />
      <Path d="M30,0 L30,30 M0,15 L60,15" stroke="#C8102E" strokeWidth={8} />
    </Svg>
  );
}
